import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
import CallbackView from '../views/CallbackView.vue'
import LoginView from '../views/LoginView.vue'
import AuthView from '../views/AuthView.vue'
// import FAQView from '../views/FAQView.vue'
import LibraryView from '../views/LibraryView.vue'
import DocumentView from '../views/DocumentView.vue'
import BroadcastView from '../views/BroadcastView.vue'
import BroadcastDetailView from '../views/BroadcastDetailView.vue'
import BroadcastSentView from '../views/BroadcastSentView.vue'
import BroadcastHistoryView from '../views/BroadcastHistoryView.vue'
import ConfigChannelView from '../views/ConfigChannelView.vue'
import ConfigServiceView from '../views/ConfigServiceView.vue'
import ConfigSentView from '../views/ConfigSentView.vue'
import PaymentsView from '../views/PaymentsView.vue'
import PaymentsDetailView from '../views/PaymentsDetailView.vue'
import AccountView from '../views/AccountView.vue'
import AccountWithdrawalView from '../views/AccountWithdrawalView.vue'
import InformationView from '../views/InformationView.vue'
import InformationDetailView from '../views/InformationDetailView.vue'
import ContactView from '../views/ContactView.vue'
import ContactSentView from '../views/ContactSentView.vue'
import AboutBoccoChannelView from '../views/AboutBoccoChannelView.vue'
import TeamView from '../views/TeamView.vue'
import InviteAcceptView from '../views/InviteAcceptView.vue'
import RoomsView from '../views/RoomsView.vue'
import RoomDetailView from '../views/RoomDetailView.vue'
import { getModule } from 'vuex-module-decorators'
import { Meta } from '@/store/meta'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardView,
    meta: {
      title: "ダッシュボード"
    }
  },
  {
    // Issue #267: GET /v1/rooms の結果を管理画面上で可視化する。
    // 個人アカウントは参加部屋、法人アカウントは BOCCOチャンネル購読部屋が表示される
    // (API 側で JWT の plan クレームから自動振り分け)。
    path: '/rooms',
    name: 'Rooms',
    component: RoomsView,
    meta: {
      title: "部屋一覧"
    }
  },
  {
    path: '/rooms/:uuid',
    name: 'RoomDetail',
    component: RoomDetailView,
    meta: {
      title: "部屋詳細"
    }
  },
  {
    path: '/callback',
    name: 'Callback',
    component: CallbackView,
    meta: {
      title: "Loading...",
      public: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: {
      title: "ログイン",
      public: true
    }
  },
  {
    path: '/login/auth',
    name: 'Auth',
    component: AuthView,
    meta: {
      title: "認証",
      public: true
    }
  },
  {
    path: '/document',
    alias: '/api-docs',
    name: 'Document',
    component: DocumentView,
    meta: {
      title: "APIドキュメント",
      public: true
    }
  },
  {
    path: '/library',
    name: 'Library',
    component: LibraryView,
    meta: {
      title: "ライブラリ",
    }
  },
  {
    path: '/messages',
    name: 'Broadcast',
    component: BroadcastView,
    meta: {
      title: "メッセージ配信",
      commercial: true,
      denyViewer: true,
    }
  },
  {
    path: '/messages/create',
    name: 'CreateBroadcast',
    component: BroadcastSentView,
    meta: {
      title: "メッセージ作成",
      commercial: true,
      denyViewer: true,
    }
  },
  {
    path: '/messages/:id',
    name: 'BroadcastDetail',
    component: BroadcastDetailView,
    meta: {
      title: "メッセージ詳細",
      commercial: true,
      denyViewer: true,
    }
  },
  {
    path: '/message-histories',
    name: 'BroadcastHistory',
    component: BroadcastHistoryView,
    meta: {
      title: "メッセージ配信履歴",
      commercial: true
    }
  },
  {
    path: '/message-histories/:id',
    name: 'BroadcastHistoryDetail',
    component: BroadcastDetailView,
    meta: {
      title: "メッセージ詳細",
      commercial: true
    }
  },
  {
    path: '/bocco-channel',
    name: 'ConfigChannel',
    component: ConfigChannelView,
    meta: {
      title: "BOCCOチャンネル",
      commercial: true,
    }
  },
  {
    path: '/bocco-channel/services/:id',
    name: 'ConfigService',
    component: ConfigServiceView,
    meta: {
      title: "BOCCOチャンネル",
      commercial: true
    }
  },
  {
    path: '/bocco-channel/done',
    name: 'ConfigSent',
    component: ConfigSentView,
    meta: {
      title: "BOCCOチャンネル",
      commercial: true,
      denyViewer: true,
    }
  },
  {
    path: '/payments',
    name: 'Payments',
    component: PaymentsView,
    meta: {
      title: "請求書",
      commercial: true,
      requireOwner: true,
    }
  },
  {
    path: '/payments/:id',
    name: 'PaymentsDetail',
    component: PaymentsDetailView,
    meta: {
      title: "請求詳細",
      commercial: true,
      requireOwner: true,
    }
  },
  {
    path: '/account',
    name: 'Account',
    component: AccountView,
    meta: {
      title: "アカウント管理",
      commercial: true
    }
  },
  {
    path: '/account-withdrawal',
    name: 'AccountWithdrawal',
    component: AccountWithdrawalView,
    meta: {
      requireOwner: true,
    }
  },
  {
    path: '/team',
    name: 'Team',
    component: TeamView,
    meta: {
      title: "メンバー管理",
      commercial: true,
      requireOwner: true,
    }
  },
  {
    path: '/invite/:token',
    name: 'InviteAccept',
    component: InviteAcceptView,
    meta: {
      title: "招待アカウントの登録",
      public: true,
    }
  },
  {
    path: '/information',
    name: 'Information',
    component: InformationView,
    meta: {
      title: "お知らせ",
    }
  },
  {
    path: '/information/:id',
    name: 'InformationDetail',
    component: InformationDetailView,
    meta: {
      title: "お知らせ",
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView,
    meta: {
      title: "お問い合わせ",
    }
  },
  {
    path: '/contact/sent',
    name: 'ContactSent',
    component: ContactSentView,
    meta: {
      title: "お問い合わせ",
    }
  },
  {
    path: '/what-is-bocco-channel',
    name: 'AboutBoccoChannel',
    component: AboutBoccoChannelView,
    meta: {
      title: "BOCCOチャンネルとは"
    }
  }
  /*
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQView
  }
  */
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      Vue.nextTick(() => {
        const el = document.querySelector(to.hash)
        el?.scrollIntoView()
      })
    }
    return {x: 0, y: 0}
  },
})

router.beforeEach((to, from, next) => {
  const meta = getModule(Meta)
  const isLogin = meta.login
  const isBusinessUser = meta.plan != 'free'

  if (!to.meta) {
    next()
    return
  }

  // check public page
  if (to.meta.public == true) {
    next()
    return
  }

  // non-public page
  if (!isLogin) {
    next("/login")
    return
  }

  // only-business page
  if (to.meta.commercial == true) {
    if (!isBusinessUser) {
      next("/login")
      return
    }
  }

  // owner 限定ページ: viewer/member は弾く
  if (to.meta.requireOwner == true && !meta.isOwner) {
    // viewer は履歴ページ、member はダッシュボードに戻す
    next(meta.isViewer ? "/message-histories" : "/")
    return
  }

  // viewer 拒否ページ: viewer はリダイレクト
  if (to.meta.denyViewer == true && meta.isViewer) {
    next("/message-histories")
    return
  }

  next()
})

export default router
